import { render, staticRenderFns } from "./milestoneDetail.vue?vue&type=template&id=172df050&scoped=true&"
import script from "./milestoneDetail.vue?vue&type=script&lang=js&"
export * from "./milestoneDetail.vue?vue&type=script&lang=js&"
import style0 from "./milestoneDetail.vue?vue&type=style&index=0&id=172df050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172df050",
  null
  
)

export default component.exports